import { render } from "./Tarefa.vue?vue&type=template&id=73ab5ea8"
import script from "./Tarefa.vue?vue&type=script&lang=ts"
export * from "./Tarefa.vue?vue&type=script&lang=ts"
script.render = render

export default script